/** True for localhost / local dev hosts where the user must pick a company manually. */
export function isLocalDevHost(hostname: string = typeof window !== 'undefined' ? window.location.hostname : 'localhost'): boolean {
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.includes('localhost') ||
    hostname.includes('replit')
  );
}

const PRIVATE_LAN_HOST =
  /^(127\.0\.0\.1|0\.0\.0\.0|192\.168\.\d{1,3}\.\d{1,3}|10\.\d{1,3}\.\d{1,3}\.\d{1,3}|172\.(1[6-9]|2\d|3[0-1])\.\d{1,3}\.\d{1,3})$/;

/**
 * When the UI is opened on localhost, rewrite LAN-IP API URLs to localhost (same port/path).
 * Stops DHCP Wi-Fi IP changes from breaking local runs; leaves production hosts unchanged.
 */
export function pinUrlToLocalhostIfLocalUi(url: string | null | undefined): string | null | undefined {
  if (!url?.trim()) return url;
  if (typeof window === 'undefined' || !isLocalDevHost(window.location.hostname)) return url;
  try {
    const parsed = new URL(url);
    if (parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1') return url;
    if (!PRIVATE_LAN_HOST.test(parsed.hostname)) return url;
    parsed.hostname = 'localhost';
    parsed.protocol = 'http:';
    const path = parsed.pathname.replace(/\/$/, '');
    return `${parsed.protocol}//${parsed.host}${path}${parsed.search}`;
  } catch {
    return url;
  }
}

/**
 * Tenant identifier from production hostname, e.g. aos.staffly.pro → "aos".
 * Returns null on local dev hosts.
 */
export function getProductionTenantIdentifier(hostname: string = typeof window !== 'undefined' ? window.location.hostname : 'localhost'): string | null {
  if (isLocalDevHost(hostname)) return null;
  const subdomain = hostname.split('.')[0]?.trim();
  if (!subdomain || subdomain === 'www') return null;
  return subdomain;
}
